import React from 'react';
import t from 'prop-types';
import {colors} from '../styles';
import {Text} from '../atoms/Text';

const Empty = ({loading, message = 'No data available'}) => (
  <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
    {!loading && <Text style={{fontSize: '16px', color: colors.primary, marginBottom: '32px'}}>{message}</Text>}
  </div>);

Empty.propTypes = {
  loading: t.bool,
  message: t.string
};

export default Empty;
